import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import useCustomPageCatalog from '../hook/UseCustomPageCatalog';
import CustomPageDetailContentHeader from './CustomPageDetailContentHeader';
import CatalogCard from '../../catalog/CatalogCard';

import { useTranslation } from 'react-i18next';

const CustomPageDetailContentCatalogMiddleLayout = (props) => {

  let {
    companyContractDisplayId,
    pageBlock,
  } = props;

  const [lastItemRenderedIndex, setLastItemRenderedIndex] = useState(0);

  const numberOfItemsToRenderPc = props.pageBlock.pageBlockLayoutType.pageBlockItemsPerLinePcViewCount;
  const numberOfItemsToRenderSp = props.pageBlock.pageBlockLayoutType.pageBlockItemsPerLineSpViewCount;
  const totalNumberOfItems = props.pageBlock.pageBlockItems.length;

  let {t} = useTranslation('application');

  const showMore = (e) => {
    e.preventDefault();
    setLastItemRenderedIndex(lastItemRenderedIndex + numberOfItemsToRenderPc);
  };

  useEffect(() => {
    props.sliderInitializerRef();
  });

  useEffect(() => {
      $('.matchHeight .img img').off('load').on('load', function(){
        try {
          $('.matchHeight .img').matchHeight();
        } catch (ex) {
          console.warn('matchHeight is not available');
        }
      });
  },[props.pageBlock]);

  console.log('Rendering catalog-middle');

  let {
    getCatalogs,
  } = useCustomPageCatalog();

  let itemsToRenderIndex = lastItemRenderedIndex + numberOfItemsToRenderPc;

  // console.log('# of items to render is: ', this.numberOfItemsToRenderPc);
  // console.log('# of items to render index is: ', itemsToRenderIndex);

  let catalogItems = getCatalogs(companyContractDisplayId, pageBlock).slice(0, itemsToRenderIndex)
    .map((catalog, i) => {
      return <CatalogCard columns={numberOfItemsToRenderPc} columnsSp={numberOfItemsToRenderSp} key={i} {...catalog} />
  });


  return (
    <div className="m_bdBox" id={"page_block_" + pageBlock.pageBlockId}>
      <CustomPageDetailContentHeader pageBlock={pageBlock}/>
      <div className="">
        <ul className={"product-list highlight row matchHeight"}>
          {catalogItems}
        </ul>
        {itemsToRenderIndex < totalNumberOfItems && <a className="btn btn-block btn-xxl btn-default border-0" href="#" onClick={showMore}>{t('common.seeMore')}</a>}
      </div>
    </div>
  );
};

CustomPageDetailContentCatalogMiddleLayout.propTypes = {
  companyContractDisplayId: PropTypes.number,
  pageBlock: PropTypes.any.isRequired,
  sliderInitializerRef: PropTypes.any.isRequired
};

export default CustomPageDetailContentCatalogMiddleLayout;
